import {
  CreateInvoiceArrivalLineItemInput,
  DataCoreBaseProduct,
  InvoiceArrivalItem,
  MarkupType,
  UpdateInvoiceArrivalLineItemInput,
} from "@towersystems/roam-common/lib/generated-types";
import { InvoiceArrivalItemFormValues } from "../components/InvoiceArrivalItemForm/types";

export const itemToFormInput = (
  item?: Partial<InvoiceArrivalItem>
): Partial<InvoiceArrivalItemFormValues> => {
  const retailMarkup =
    item?.product?.category?.markup?.find(
      (c) => c.markupType == MarkupType.RETAIL
    ) ??
    item?.product?.department?.markup?.find(
      (c) => c.markupType == MarkupType.RETAIL
    );

  const tradeMarkup =
    item?.product?.category?.markup?.find(
      (c) => c.markupType == MarkupType.TRADE
    ) ??
    item?.product?.department?.markup?.find(
      (c) => c.markupType == MarkupType.TRADE
    );

  const webMarkup =
    item?.product?.category?.markup?.find(
      (c) => c.markupType == MarkupType.TRADE
    ) ??
    item?.product?.department?.markup?.find(
      (c) => c.markupType == MarkupType.TRADE
    );

  return {
    id: item?.id ?? "",
    productId: item?.productId ?? item?.product?.id ?? undefined,
    barcode: item?.barcode ?? "",
    quantity: item?.quantity?.toString() ?? "0",
    costPrice: item?.costPrice?.toString() ?? "0",
    retailPrice: item?.retailPrice?.toString() ?? "0",
    serialNumbers: item?.serialNumbers ?? [],
    webPrice:
      item?.webPrice?.toString() ?? item?.retailPrice?.toString() ?? "0",
    tradePrice:
      item?.tradePrice?.toString() ?? item?.retailPrice?.toString() ?? "0",
    /* ui fields */
    retailMarkup: retailMarkup,
    tradeMarkup: tradeMarkup,
    webMarkup: webMarkup,
    name: item?.name ?? "",
  };
};

export const invoiceLineItemDataToGraphqlInput = (
  input: InvoiceArrivalItemFormValues
): UpdateInvoiceArrivalLineItemInput | CreateInvoiceArrivalLineItemInput => {
  let i: UpdateInvoiceArrivalLineItemInput | CreateInvoiceArrivalLineItemInput =
    {
      productId: input.productId,
      barcode: input.barcode,
      quantity: parseFloat(input.quantity ?? 0),
      received: parseFloat(input.quantity ?? 0),
      costPrice: parseFloat(input.costPrice ?? 0),
      retailPrice: parseFloat(input.retailPrice ?? 0),
      webPrice: parseFloat(input.webPrice ?? 0),
      tradePrice: parseFloat(input.tradePrice ?? 0),
      serialNumbers: input.serialNumbers ?? [],
      name: input.name ?? "",
    };

  if (input.id) {
    i = { ...i, id: input.id };
  }

  return i;
};

export const dataCoreProductToFormInput = (
  product: DataCoreBaseProduct | undefined
): Partial<InvoiceArrivalItemFormValues> => {
  if (!product) {
    return {
      productId: undefined,
      barcode: "",
      quantity: "0",
      costPrice: "0",
      retailPrice: "0",
      tradePrice: "0",
      webPrice: "0",
      name: "",
    };
  }

  const inventoryPricing = product?.inventoryPricing?.[0];

  return {
    productId: undefined,
    barcode: product.sku,
    quantity: "0",
    costPrice: inventoryPricing.stockCost?.toString() ?? "0",
    retailPrice: inventoryPricing.stockRetail?.toString() ?? "0",
    tradePrice: "0",
    webPrice: inventoryPricing.stockRetail?.toString() ?? "0",
    name: product.stockDescription,
  };
};
